/* eslint-disable react/prop-types */
//@ts-check

/**@type {import('../types').DataType<import('./types').UserModel>} */
var USER_DATA_TYPE = {
  extends: 'user',
  data: {
    itemUrl: '/backend/users?userId={id}',
    dataKey: 'userId',
    idKeyProp: 'Id'
  }
};
export default USER_DATA_TYPE;